module.exports = __webpack_public_path__ + "static/media/Logo_RGB.7f177d61.png";